<template>
	<div class="contact-main">
		
		<div class="title wi8_font">
			Send Us a Message!
			<div class="title-ico">
				<UniIcon ico="message" color="#369" fit="1" />
			</div>
		</div>

		<div class="v-space"></div>

		<div class="mess-line">
			<div class="label wi8_font">
				<UniIcon ico="asterisk" color="#C30" w="20" h="12" pad="0" />
				My Name:
			</div>
			<div :class="'flag-box-' + flags.name">
				<div class="pop-value-box" @click="popInput('name')" v-html="rec.name"></div>
			</div>
		</div>

		<div class="v-space"></div>

		<div class="mess-line">
			<div class="label wi8_font">
				<UniIcon ico="asterisk" color="#C30" w="20" h="12" pad="0" />
				My Email:
			</div>
			<div :class="'flag-box-' + flags.email">
				<div class="pop-value-box" @click="popInput('email')" v-html="rec.email"></div>
			</div>
		</div>

		<div class="v-space"></div>

		<div class="mess-line">
			<div class="label wi8_font">
				<UniIcon ico="asterisk" color="#C30" w="20" h="12" pad="0" />
				Subject:
			</div>
			<div :class="'flag-box-' + flags.subj">
				<div class="pop-value-box" @click="popInput('subj')" v-html="rec.subj"></div>
			</div>
		</div>

		<div class="v-space"></div>

		<div class="label wi8_font">
			<UniIcon ico="asterisk" color="#C30" w="20" h="12" pad="0" />
			Message: (200 chars max)
		</div>

		<div class="mess-text-line">
			<div :class="'flag-box-' + flags.messText">
				<div class="pop-value-box pop-textarea" @click="popInput('messText')" v-html="convertLFs(rec.messText)"></div>
			</div>
		</div>

		<div class="v-space"></div>

		<div class="label wi8_font">
			<UniIcon ico="asterisk" color="#C30" w="20" h="12" pad="0" />
			= required
		</div>

		<div class="v-space"></div>


		Clear Message <span style="float:right">Click to Send!</span>
		<div class="v-space"></div>

		<div class="btn-clear" @click="clickClear">
			<UniIcon ico="cancel" color="#C30" fit="1" />
		</div>
		<div class="btn-send wi8_font" @click="clickSend">
			Send
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils"
import * as Utils from "@/utils/utils";
import CfgApp from "@/assets/cfg/CfgApp";
import { mapState } from 'vuex';
import { eventBus } from '@/main';
export default {
	data() {
		return {
			rec:	{name:""	,email:""	,subj:""	,messText:""},
			flags:	{name:true	,email:true	,subj:true	,messText:true},
		};
	},
	computed: {
		...mapState('app',['contact']),
	},
	watch: {
		contact: {
			immediate: true,
			deep: true,
			handler(newVal, oldVal) {
				m("watch contact changed", oldVal,  newVal);
				this.rec = {...newVal};
			}
		}
	},
	updated() {
		m("updated", this.rec);
	},
	methods: {
		popInput(colName) {
			m("contact popinput", colName, this.rec);
			Utils.showPopInput(colName, this.rec[colName]);
		},
		handleUpdateVal(payload) {
			let colName = payload.colName;
			let val = payload.val;
			this.rec[colName] = val;
			m("rec is now", this.rec);
		},
		convertLFs(str1="") {
			let str2 = str1.replace(/\n/g, '<br/>', );
			return str2;
		},
		updateRec() {
			m("update rec", this.rec);
			const data = {
				rec: this.rec,
			};
			this.$store.dispatch("app/setContact", data);
		},
		clickClear() {
			// Clear values & flags
			for (let key of Object.keys(this.rec)) {
				this.rec[key] = "";
				this.flags[key] = true;
			}
			// Set state
			const data = {
				rec: this.rec,
			};
			this.$store.dispatch("app/setContact", data);
			// this.$forceUpdate();
		},
		clickSend() {
			if (this.validated()) {
				m("ready to send");

				const payloadContact = {
					rec: this.rec,
				}

				const payloadPost = {
					popType: "win",
					popTitle: "Sending Message",
					popText: "",
					compName: "UniPost",
					compData: {
						step: "contact",
						autoPost: true,
					},
				};

				// Save info, then Post
				this.$store.dispatch("app/setContact", payloadContact)
					.then( () => {
						eventBus.$emit("popup", payloadPost);	
					})

		} else {
				m("invalid");
			}

		},
		validated() {
			let emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			this.flags.name = this.fixVal("name");
			this.flags.email = this.fixVal("email", emailPattern);
			this.flags.subj = this.fixVal("subj");
			this.flags.messText = this.fixVal("messText");
			m("flags", this.flags);
			// this.$forceUpdate();
			return (this.flags.name && this.flags.email && this.flags.subj && this.flags.messText);
		},
		fixVal(colName, pattern) {
			m("fixing", colName);
			m(this.rec);
			let newVal = this.rec[colName] || "";
			newVal = newVal.trim();
			let answer = true;
			if (newVal.length>0) {
				if (pattern != "undefined") {
					const regex	= new RegExp(pattern);
					answer = regex.test(newVal);
				}
			} else {
				answer = false;
			}
			return answer;
		},
	},
	created() {
		m("contact created", this.rec);
		eventBus.$emit('popoffall'); // Close all modal windows
		eventBus.$on('update-value', this.handleUpdateVal);
	},
	beforeDestroy() {
		m("contact txt bef destroy");
		this.updateRec();
		eventBus.$off('update-value', this.handleUpdateVal);
	},
}
</script>

<style scoped>
.contact-main {
	height: 100%;
	overflow: hidden;
	background-color: #F6F6F6;
	padding: 20px 20px 0px 20px;
	border: solid 0px #090;
}

.title {
	height: 40px;
	overflow: hidden;
	color: #369;
	border: solid 0px #000;
}

.title-ico {
	float: right;
	width: 40px;
	height: 40px;
	overflow: hidden;
	border: solid 0px #F60;
}

.mess-line {
	height: 30px;
	overflow: hidden;
	border: solid 0px #F60;
}

.mess-text-line {
	height: 130px;
	overflow: hidden;
	border: solid 0px #F60;
}

.label {
	display: inline-block;
	width: 120px;
	height: 25px;
	/* overflow: hidden; */
	white-space: nowrap;
	vertical-align: top;
	color: #369;
	border: solid 0px #090;
}

.pop-value-box {
	display: inline-block;
	width: 180px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

.pop-textarea {
	height: 120px;
	width: 300px;
	overflow-x: none;
	overflow-y: auto;
}

.flag-box-true {
	display: inline-block;
	border: solid 0px #999 !important;
}

.flag-box-false {
	display: inline-block;
	border: solid 2px #C30 !important;
}

.btn-clear {
	display: inline-block;
	width: 80px;
	height: 40px;
	overflow: hidden;
	cursor: pointer;
	background-color: #FFF;
	border-radius: 5px;
	border: solid 2px #369;
}

.btn-send {
	float: right;
	width: 80px;
	height: 40px;
	overflow: hidden;
	font-size: 20px;
	color: #369;
	cursor: pointer;
	background-color: #FFF;
	padding: 5px 0px 0px 10px;
	border-radius: 5px;
	border: solid 2px #369;
}

.v-space {
	width: 10px;
	height: 10px;
	overflow: hidden;
	border: solid 0px #999;
}
</style>
